import { UpdateRolePermissionPayload } from "constants/types/permission";
import { request } from "./base";

const prefix = "/permission";

export const permissionApi = {
  getPermissions: () => {
    return request({
      url: `${prefix}`,
      method: "GET",
    });
  },

  updateRolePermissions: (data: UpdateRolePermissionPayload) => {
    return request({
      url: `${prefix}/role`,
      method: "PUT",
      data,
    });
  },
};
